import db from "@/plugins/dexie";
import apivarejoweb from '@/services/api-varejoweb';
import moment from "moment-timezone";
import store from "@/store";

const tabela = 'veiculo';
const idnuvem = 'veiidnuvem';

export default async function $_enviaVeiculo(idParentLocal = null) {
  const tokenString = sessionStorage.getItem('auth:token');

  if (!tokenString || tokenString === 'undefined' || tokenString === 'null') {
    return;
  }
  const token = JSON.parse(tokenString);

  let veiculos = await db[tabela].toArray();

  if (idParentLocal) {
    const parentOS = await db.prestacaoservico.get(idParentLocal);
    if (parentOS) {
      veiculos = veiculos.filter(v => {
        const idVei = v.veiidnuvem || v.veiidveiculo || v.id;
        const matchId = parentOS.prsidveiculo && (String(idVei) === String(parentOS.prsidveiculo));
        const matchPlaca = parentOS.prsplaca && v.veiplaca && 
          (v.veiplaca.toString().replace(/[^a-zA-Z0-9]/g, '').toLowerCase() === parentOS.prsplaca.toString().replace(/[^a-zA-Z0-9]/g, '').toLowerCase());
        return matchId || matchPlaca;
      });
    } else {
      veiculos = [];
    }
  }

  // Filtrar veículos não transmitidos ou alterados recentemente
  veiculos = veiculos.filter(v => {
    const semTransmissao = !v.veidatatransmissao || v.veidatatransmissao === 'null';
    const semIdNuvem = !v[idnuvem] || v[idnuvem] === 'null';
    
    if (semTransmissao || semIdNuvem) {
      return true;
    }

    const dtAlteracao = moment(v.veidataalteracao);
    const dtTransmissao = moment(v.veidatatransmissao);
    return dtAlteracao.isValid() && dtTransmissao.isValid() && dtAlteracao.isAfter(dtTransmissao);
  });

  if (veiculos.length === 0) return;

  const formataData = (data, formato) => {
    if (!data || data === 'null' || data === '') return null;
    const m = moment(data);
    return m.isValid() ? m.format(formato) : null;
  };

  const safeInt = (val) => {
    if (val === null || val === undefined || val === '' || val === 'null') return null;
    const num = Number(val);
    if (isNaN(num) || num > 2147483647 || num < -2147483648) return null;
    return num;
  };

  const promises = veiculos.map(async (item) => {
    const payload = {
      DESCRICAO: item.veidescricao || item.descricao || null,
      PLACA: item.veiplaca ? String(item.veiplaca).trim().toUpperCase() : null,
      IDCOR: safeInt(item.veiidcor ?? item.IDCOR ?? item.idcor),
      CorDescricao: item.veicor || null,
      IDMARCA: safeInt(item.veiidmarca ?? item.IDMARCA ?? item.idmarcaveiculo ?? item.mavidmarcaveiculo),
      MarcaDescricao: item.veimarcanome || item.vaimarcanome || null,
      Frota: item.veifrota ? String(item.veifrota).trim() : null,
      COMBUSTIVEL: item.veicombustivel ? String(item.veicombustivel).trim().slice(0, 1).toUpperCase() : null,
      ANO: safeInt(item.veiano),
      ANOMODELO: safeInt(item.veianomodelo),
      IDCLIENTE: safeInt(item.veiidcliente),
      NroCHASSI: item.veichassi ? String(item.veichassi).trim() : null,
      NUMEROSERIE: item.veinumeroserie ? String(item.veinumeroserie).trim() : null,
      KM: safeInt(item.veikm),
      Motor: item.veimotor ? String(item.veimotor).trim() : null,
      DataCadastro: formataData(item.veidataalteracao || item.veidatainclusao, 'YYYY-MM-DD HH:mm:ss') || moment().format('YYYY-MM-DD HH:mm:ss')
    };

    let res = null;
    try {
      const jaTransmitido = item.veidatatransmissao && item.veidatatransmissao !== 'null';
      const temIdNuvemValido = item[idnuvem] && item[idnuvem] !== 'null' && String(item[idnuvem]) !== String(item.id);

      if (jaTransmitido && temIdNuvemValido) {
        res = await apivarejoweb.put(`/veiculo/${item[idnuvem]}`, payload, {
          headers: { Authorization: `Bearer ${token.token}` }
        });
      } else {
        delete payload.id;
        delete payload.IDVEICULO;
        res = await apivarejoweb.post('/veiculo', payload, {
          headers: { Authorization: `Bearer ${token.token}` }
        });
      }
    } catch (err) {
      console.error(`❌ [enviaVeiculo] Erro ao enviar veículo ${item.id}:`, err.response?.data || err);
    }

    if (res && res.data) {
      const dataTransmissao = moment().format('YYYY-MM-DD HH:mm:ss.SSS');
      const newNuvemId = res.data.id ?? res.data.IDVEICULO ?? res.data.idveiculo ?? item[idnuvem];

      await db[tabela].update(item.id, {
        veiidnuvem: newNuvemId,
        veiidveiculo: newNuvemId,
        veidatatransmissao: dataTransmissao,
      });

      if (idParentLocal) {
        await db.prestacaoservico.update(idParentLocal, {
          prsidveiculo: newNuvemId
        });
      }

      store.dispatch('cache/atualizaData', { data: dataTransmissao, tabela: 'veiculo' });
    }

    return res;
  });

  await Promise.all(promises);
  await store.dispatch('cache/reloadCache', 'veiculo');
}
